export const GRID_DEFAULT_STRIP_INDEX = 5;
export const GRID_STRIP_HEIGHT_MOBILE = 900;
export const GRID_STRIP_HEIGHT_DESKTOP = 500;

export const TORPEDO_DEFAULT_STRIP_OFFSET = 2;
